import React from 'react';
import TermsModal from 'components/TermsModal';
import { colors } from 'components/Theme';
import markdownContent from '!!raw-loader!static/accessibility.md';
import { Markdown } from 'Common';

export function AccessibilityLink({
  className,
  linkClassName,
  buttonColor = 'link',
  buttonText = 'Angaben zur Barrierefreiheit',
  modalHeaderText = 'Angaben zur Barrierefreiheit',
  color = colors.green.c500,
  renderAs = 'link',
  children
}) {
  return (
    <TermsModal
      buttonColor={buttonColor}
      buttonClasses={className}
      linkClasses={linkClassName}
      modalHeaderText={modalHeaderText}
      buttonText={children || buttonText}
      renderAs={renderAs}
      color={color}
    >
      <Markdown className="popup" containerId="modal-body" scrollOffset={0}>
        {markdownContent}
      </Markdown>
    </TermsModal>
  );
}
